import gql from "graphql-tag";
import { toast } from "react-toastify";

import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";
import ParcisionCookies from "../../../utils/Cookies";

export default async function getContract(cid: number) {
  try {
    const address = ParcisionCookies.get("address");
    const variables = { cid, address };

    const query = gql`
      query MyQuery($cid: Float!, $address: String!) {
        getContract(cid: $cid, address: $address) {
          contract {
            cidaddr
            gparam
            cparam0
            num
            cparam1
            cparam2
            cparam3
            expiresnap
            image
          }
          event {
            eventwebsite
            eventdescription
          }
          object {
            symbol
            exchange
            cik
            companyname
            sector
            industry
            stylev
            styleh
            objectdescription
            objectwebsite
          }
          stats {
            snap
            goptin
            gprize
          }
          local {
            snap
            stage
            estimate1
            estimate2
            estimate3
            wager
            description
            research
            tid
          }
          participants {
            addr
            snap
            tid
            estimate1
            estimate2
            estimate3
            wager
            return
            description
            research
          }
          result {
            true_value_1
            true_value_2
            true_value_3
            decode
            payout
          }
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.getContract;
  } catch (error) {
    toast.error("Failed to collect contract information.");
    sentryWrappedException(error);
    throw error;
  }
}
